/**
 * An internal row drag carries the row as text/plain; a desktop drag carries
 * Files. Only the types are readable before the drop.
 */
export const isInternalDrag = (e: {
  dataTransfer: { types: readonly string[] };
}) =>
  !e.dataTransfer.types.includes("Files") &&
  e.dataTransfer.types.includes("text/plain");
